import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('pqOverSrgAltrStore', Object.keys(getters)),
	...mapState('pqOverSrgAltrStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('pqOverSrgAltrStore', Object.keys(actions)),
	...mapMutations('pqOverSrgAltrStore', Object.keys(mutations))
};
